<template>
  <div class="most-products">
    <b-overlay :show="loading">
      <div class="most-products__grid" style="min-height: 250px">
        <div v-if="showingFallback && productList.length" class="most-products__notice" role="status">
          <b-icon icon="info-circle" aria-hidden="true" />
          Por ahora te mostramos productos disponibles del catálogo.
        </div>
        <div class="most-products__item" v-for="product in productList" :key="product._id">
          <single-product :data="product" product-template="category-showcase" />
        </div>
        <div
          class="most-products__empty text-center text-muted py-5"
          v-if="!loading && productList.length === 0"
        >
          {{ loadError ? "No pudimos cargar los productos." : "Aún no hay productos disponibles." }}
          <button v-if="loadError" type="button" class="btn btn-link d-block mx-auto" @click="load">
            Reintentar
          </button>
        </div>
        <slot></slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
//import singleProduct from "../components/singleProduct";
const singleProduct = () => import(/* webpackChunkName: "singleproduct" */"../components/singleProduct.vue");

export default {
  components: {
    singleProduct,
  },
  props: {
    id: { type: [String, Number], default: null },
    params: { type: String, default: "" },
    mostProductsLimit: { type: [Number, String], default: null },
  },
  data() {
    return {
      products: [],
      loading: true,
      showingFallback: false,
      loadError: false,
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    webName(next, previous) {
      if (next && next !== previous) this.load();
    },
  },
  methods: {
    async load() {
      if (!this.webName) {
        this.loading = false;
        return;
      }

      this.loading = true;
      this.loadError = false;
      this.showingFallback = false;

      try {
        let bestSellers = [];
        try {
          const response = await this.$http.get(`${this.webName}/product/mostselled`);
          bestSellers = Array.isArray(response.data.data) ? response.data.data : [];
        } catch (error) {
          bestSellers = [];
        }

        if (bestSellers.length) {
          this.products = bestSellers;
          return;
        }

        const response = await this.$http.get(`${this.webName}/product?order=createdAt&limit=${this.configuredLimit}`);
        this.products = Array.isArray(response.data.data) ? response.data.data : [];
        this.showingFallback = this.products.length > 0;
      } catch (error) {
        this.products = [];
        this.loadError = true;
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    webName() {
      return this.$store.state.info && this.$store.state.info.webName;
    },
    configuredLimit() {
      const legacyLimit = this.params.split(",")
        .map((part) => part.trim().split("="))
        .find(([key]) => key === "limit");
      const limit = Number(this.mostProductsLimit || (legacyLimit && legacyLimit[1])) || 4;
      return Math.min(12, Math.max(1, Math.floor(limit)));
    },
    productList() {
      return this.products.slice(0, this.configuredLimit);
    }
  }
};
</script>

<style scoped>
.most-products {
  padding: clamp(8px, 2vw, 28px) clamp(4px, 1.5vw, 20px);
}

.most-products__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(14px, 2vw, 28px);
  align-items: stretch;
}

.most-products__item {
  min-width: 0;
}

.most-products__notice,
.most-products__empty {
  grid-column: 1 / -1;
}

.most-products__notice {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 14px;
  border: 1px solid #e4ebf3;
  border-radius: 12px;
  background: #f8fafc;
  color: #62758a;
  font-size: 0.82rem;
}

@media (max-width: 991.98px) {
  .most-products__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .most-products {
    padding: 8px 4px 18px;
  }

  .most-products__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
}
</style>
